if (typeof IntersectionObserver === 'undefined') {
    require('intersection-observer');
}

export function delayedRender(target: Element, data: {items: Array<any>})
{
    if (target.firstElementChild === null) {
        return;
    }
    
    let template = target.firstElementChild;

    data.items.forEach(item => {
        let node = template.cloneNode(true) as HTMLElement;

        for (let key in item) {
            let child = node.querySelector(`[data-key="${key}"]`);
            let value = typeof item[key] === 'undefined' ? null : item[key];

            if (child === null) {
                continue;
            }
            
            switch (child.tagName) {
                case 'IMG':
                    if (value !== null) {
                        child.setAttribute('src', value);
                    }
                    break;

                default:
                    child.innerHTML = value === null ? '' : value;
            }
        }

        target.appendChild(node);
    });

    template.remove();
}

export default function initDelayedRender()
{
    if (typeof window['delayedRender'] === 'undefined') {
        return;
    }

    for (let id in window['delayedRender']) {
        let target = document.getElementById(id);
        let data   = window['delayedRender'][id];

        if (target === null || data === null) {
            return;
        }

        let observer = new IntersectionObserver(
            (entries, observer) => {
                Array.prototype.forEach.call(entries, function (entry) {
                    if (entry.isIntersecting) {
                        observer.disconnect();
                        delayedRender(target, data);
                    }
                });
            },
            {rootMargin: '150px', threshold: [0]}
        );

        observer.observe(target);
    }
}
